import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { useSyncGameFiles } from '../../hooks/use-sync-game-files.hook';

export const SyncGameFilesHelper: FunctionComponent<{
  thumbnailFileId: number | null;
  zipFileId: number | null;
}> = ({
  thumbnailFileId,
  zipFileId,
  children,
}: PropsWithChildren<{
  thumbnailFileId: number | null;
  zipFileId: number | null;
}>): ReactElement => {
  useSyncGameFiles(thumbnailFileId, zipFileId);

  return <>{children}</>;
};
